import { apiFetch } from './api';

export const createPackage = (data, token) =>
  apiFetch('/packages', { method: 'POST', body: JSON.stringify(data) }, token);

export const getMyPackages = (token) =>
  apiFetch('/packages', {}, token);

export const deletePackage = (id, token) =>
  apiFetch(`/packages/${id}`, { method: 'DELETE' }, token);

export const updatePackage = (id, data, token) =>
  apiFetch(`/packages/${id}`, { method: 'PUT', body: JSON.stringify(data) }, token);

export const getPackagesDisponibles = (token) =>
  apiFetch('/packages/disponibles', {}, token);

export const aceptarPackage = (id, token) =>
  apiFetch(`/packages/${id}/aceptar`, { method: 'PUT' }, token);

export const getPackageById = (id, token) =>
  apiFetch(`/packages/${id}`, {}, token);
